<template>
  <BlocoFormularioCadastro voltar="/paciente/" @salvar="salvar()">
    <template #form>
      <div
        :class="{
          'panel-primary': !v$.$validationGroups.geral.$error,
          'panel-danger': v$.$validationGroups.geral.$error,
        }"
        class="panel"
      >
        <div id="info_gerais" class="panel-heading" role="tab">
          <h4 class="panel-title">
            Geral
            <span class="pull-right">{{ paciente.nome }}</span>
          </h4>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-8 col-md-5 col-lg-5">
              <div
                :class="{ 'has-error': v$.paciente.nome.$error }"
                class="form-group"
              >
                <input
                  id="_id"
                  v-model="paciente._id"
                  data-test-id="input-_id"
                  type="hidden"
                  name="_id"
                  class="form-control"
                />
                <label for="nome"
                  >Nome
                  <sup>(1)</sup>
                </label>
                <input
                  id="nome"
                  v-model="paciente.nome"
                  data-test-id="input-paciente-nome"
                  type="text"
                  class="form-control"
                  name="nome"
                  placeholder="Nome completo"
                  @input="v$.paciente.nome.$touch()"
                />
                <span v-if="v$.paciente.nome.$dirty">
                  <span v-if="!v$.paciente.nome.required" class="help-block"
                    >Campo é obrigatório.</span
                  >
                  <span v-if="!v$.paciente.nome.minLength" class="help-block"
                    >Campo deve ter pelo menos
                    {{ v$.paciente.nome.$params.minLength.min }} letras.</span
                  >
                  <span v-if="!v$.paciente.nome.maxLength" class="help-block"
                    >Campo deve ter no máximo
                    {{ v$.paciente.nome.$params.maxLength.max }} letras.</span
                  >
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-2 col-lg-2">
              <div
                :class="{ 'has-error': v$.paciente.data_nascimento.$error }"
                class="form-group"
              >
                <label for="data_nascimento"
                  >Data Nascimento
                  <sup>(1)</sup>
                </label>
                <div id="data_nascimento" class="input-group">
                  <input
                    v-model="paciente.data_nascimento"
                    v-mask="'99/99/9999'"
                    data-test-id="input-paciente-data_nascimento"
                    type="text"
                    class="form-control"
                    placeholder="DD/MM/AAAA"
                    @input="v$.paciente.data_nascimento.$touch()"
                  />
                  <div class="input-group-addon">
                    <span
                      type="button"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="fa fa-calendar" />
                    </span>
                    <span class="dropdown-menu dropdown-menu-right">
                      <li>
                        <DatePicker
                          v-model="paciente.data_nascimento"
                          :today-btn="false"
                          :clear-btn="false"
                          :format="'dd/MM/yyyy'"
                          :close-on-selected="true"
                          :date-parser="dataParser"
                          class="date-picker"
                        />
                      </li>
                    </span>
                  </div>
                </div>
                <span v-if="v$.paciente.data_nascimento.$dirty">
                  <span
                    v-if="!v$.paciente.data_nascimento.required"
                    class="help-block"
                    >Campo é obrigatório.</span
                  >
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-2 col-lg-2">
              <div class="form-group">
                <label for="estado_civil">Estado Civil </label>
                <select
                  id="estado_civil"
                  v-model="paciente.estado_civil"
                  data-test-id="select-estado_civil"
                  class="form-control"
                  name="estado_civil"
                >
                  <option disabled value="">Selecione</option>
                  <option
                    v-for="estado_civil in estados_civis"
                    :key="estado_civil._id"
                    :value="estado_civil.valor"
                    >{{ estado_civil.valor }}</option
                  >
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-2 col-lg-2">
              <div class="form-group">
                <label for="sexo">Sexo </label>
                <select
                  id="sexo"
                  v-model="paciente.sexo"
                  data-test-id="select-sexo"
                  class="form-control"
                  name="sexo"
                >
                  <option disabled value="">Selecione</option>
                  <option
                    v-for="sexo in sexos"
                    :key="sexo.id"
                    :value="sexo.valor"
                    >{{ sexo.valor }}</option
                  >
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-8 col-md-5 col-lg-5">
              <div class="form-group">
                <label for="nome_social">Nome Social </label>
                <input
                  id="nome_social"
                  v-model="paciente.nome_social"
                  data-test-id="input-nome_social"
                  type="text"
                  class="form-control"
                  name="nome_social"
                  placeholder="Nome social"
                />
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <div class="form-group">
                <label for="idade">Profissão</label>
                <select
                  id="profissao"
                  v-model="paciente.profissao"
                  data-test-id="select-profissao"
                  class="form-control"
                  name="profissao"
                >
                  <option disabled value="">Selecione</option>
                  <option
                    v-for="profissao in profissoes"
                    :key="profissao.id"
                    :value="profissao.valor"
                    >{{ profissao.valor }}</option
                  >
                </select>
              </div>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <div class="form-group">
                <label>Situação</label>
                <select
                  id="ativo"
                  v-model="paciente.ativo"
                  data-test-id="select-ativo"
                  name="ativo"
                  class="form-control"
                >
                  <option :value="true">Ativo</option>
                  <option :value="false">Cancelado</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel panel-primary">
        <div id="endereco_panel_titulo" class="panel-heading" role="tab">
          <h4 class="panel-title">
            Endereço
            <span class="pull-right">{{ resumoEndereco }}</span>
          </h4>
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-4 col-md-2 col-lg-2">
              <div class="form-group">
                <label for="cep">CEP</label>
                <input
                  id="cep"
                  v-model="paciente.endereco.cep"
                  v-mask="'99999-999'"
                  data-test-id="input-cep"
                  type="text"
                  class="form-control"
                  name="cep"
                  placeholder="CEP"
                  @change="alterouCep()"
                />
              </div>
            </div>
            <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8">
              <div class="form-group">
                <label for="endereco">Endereço</label>
                <input
                  id="endereco"
                  v-model="paciente.endereco.endereco"
                  data-test-id="input-endereco"
                  type="text"
                  class="form-control"
                  name="endereco"
                  placeholder="Endereço"
                />
              </div>
            </div>
            <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2">
              <div class="form-group">
                <label for="endereco">Número </label>
                <input
                  id="numero"
                  v-model="paciente.endereco.numero"
                  data-test-id="input-numero"
                  type="text"
                  class="form-control"
                  name="numero"
                  placeholder="Número"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
              <div class="form-group">
                <label for="bairro">Bairro </label>
                <input
                  id="bairro"
                  v-model="paciente.endereco.bairro"
                  data-test-id="input-bairro"
                  type="text"
                  class="form-control"
                  name="bairro"
                  placeholder="Bairro"
                />
              </div>
            </div>
            <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
              <div class="form-group">
                <label for="uf">UF </label>
                <select
                  id="uf"
                  v-model="paciente.endereco.uf"
                  data-test-id="select-endereco-uf"
                  class="form-control"
                  name="uf"
                  @change="recuperarCidades()"
                >
                  <option disabled value="">Selecione</option>
                  <option v-for="uf in ufs" :key="uf._id" :value="uf">{{
                    uf.sigla
                  }}</option>
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
              <div class="form-group">
                <label for="cidade">Cidade </label>
                <select
                  id="cidade"
                  v-model="paciente.endereco.cidade"
                  data-test-id="select-cidade"
                  class="form-control"
                  name="cidade"
                >
                  <option disabled value="">Selecione</option>
                  <option
                    v-for="cidade in cidades"
                    :key="cidade._id"
                    :value="cidade"
                    >{{ cidade.nome }}</option
                  >
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="form-group">
                <label for="complemento">Complemento</label>
                <input
                  id="complemento"
                  v-model="paciente.endereco.complemento"
                  data-test-id="input-complemento"
                  type="text"
                  class="form-control"
                  name="complemento"
                  placeholder="Complemento"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="{
          'panel-primary': !v$.$validationGroups.contato.$error,
          'panel-danger': v$.$validationGroups.contato.$error,
        }"
        class="panel"
      >
        <div id="contato_panel_titulo" class="panel-heading" role="tab">
          <h4 class="panel-title">
            Contato
            <span class="pull-right">{{ resumoContato }}</span>
          </h4>
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <div
                :class="{ 'has-error': v$.paciente.contato.celular.$error }"
                class="form-group"
              >
                <label for="celular"
                  >Celular
                  <sup>(2)</sup>
                </label>
                <input
                  id="celular"
                  v-model="paciente.contato.celular"
                  v-mask="'(99) 99999-9999'"
                  data-test-id="input-contato-celular"
                  type="text"
                  class="form-control"
                  name="celular"
                  placeholder="Celular"
                />
                <span v-if="v$.paciente.contato.celular.$dirty">
                  <span
                    v-if="!v$.paciente.contato.celular.required"
                    class="help-block"
                    >Celular ou Telefone para contato são obrigatórios.</span
                  >
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <div
                :class="{ 'has-error': v$.paciente.contato.telefone.$error }"
                class="form-group"
              >
                <label for="telefone"
                  >Telefone
                  <sup>(2)</sup>
                </label>
                <input
                  id="telefone"
                  v-model="paciente.contato.telefone"
                  v-mask="'(99) 9999-9999'"
                  data-test-id="input-contato-telefone"
                  type="text"
                  class="form-control"
                  name="telefone"
                  placeholder="Telefone"
                />
                <span v-if="v$.paciente.contato.telefone.$dirty">
                  <span
                    v-if="!v$.paciente.contato.telefone.required"
                    class="help-block"
                    >Celular ou Telefone para contato são obrigatórios.</span
                  >
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <div
                :class="{ 'has-error': v$.paciente.contato.email.$error }"
                class="form-group"
              >
                <label for="email">E-mail</label>
                <input
                  id="email"
                  v-model="paciente.contato.email"
                  data-test-id="input-email"
                  type="email"
                  class="form-control"
                  name="email"
                  placeholder="E-mail"
                />
                <span v-if="v$.paciente.contato.email.$dirty">
                  <span
                    v-if="!v$.paciente.contato.email.email"
                    class="help-block"
                    >Email inválido.</span
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="{
          'panel-primary': !v$.$validationGroups.contato_emergencia.$error,
          'panel-danger': v$.$validationGroups.contato_emergencia.$error,
        }"
        class="panel"
      >
        <div class="panel-heading" role="tab">
          <h4 class="panel-title">
            Contato de emergência
            <span class="pull-right">{{ resumoContatoEmergencia }}</span>
          </h4>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <div
                :class="{
                  'has-error': v$.paciente.contato_emergencia.nome.$error,
                }"
                class="form-group"
              >
                <label for="nome">
                  Nome
                  <sup>(1)</sup>
                </label>
                <input
                  id="nome"
                  v-model="paciente.contato_emergencia.nome"
                  data-test-id="input-contato-emergencia-nome"
                  type="text"
                  class="form-control"
                  name="nome"
                  placeholder="Nome"
                />
                <span v-if="v$.paciente.contato_emergencia.nome.$dirty">
                  <span
                    v-if="!v$.paciente.contato_emergencia.nome.required"
                    class="help-block"
                  >
                    Nome para contato de emergência é obrigatório.
                  </span>
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <div
                :class="{
                  'has-error': v$.paciente.contato_emergencia.celular.$error,
                }"
                class="form-group"
              >
                <label for="celular">
                  Celular
                  <sup>(1)</sup>
                </label>
                <input
                  id="celular"
                  v-model="paciente.contato_emergencia.celular"
                  v-mask="'(99) 99999-9999'"
                  data-test-id="input-contato-emergencia-celular"
                  type="text"
                  class="form-control"
                  name="celular"
                  placeholder="Celular"
                />
                <span v-if="v$.paciente.contato_emergencia.celular.$dirty">
                  <span
                    v-if="!v$.paciente.contato_emergencia.celular.required"
                    class="help-block"
                  >
                    Celular para contato de emergência é obrigatório.
                  </span>
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <div class="form-group">
                <label for="telefone"> Telefone </label>
                <input
                  id="telefone"
                  v-model="paciente.contato_emergencia.telefone"
                  v-mask="'(99) 9999-9999'"
                  data-test-id="input-contato-emergencia-telefone"
                  type="text"
                  class="form-control"
                  name="telefone"
                  placeholder="Telefone"
                />
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <div class="form-group">
                <label for="cpf"> CPF </label>
                <input
                  id="cpf"
                  v-model="paciente.contato_emergencia.cpf"
                  v-mask="'999.999.999-99'"
                  data-test-id="input-contato-emergencia-cpf"
                  type="text"
                  class="form-control"
                  name="cpf"
                  placeholder="CPF"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!menorDeIdade"
        :class="{
          'panel-primary': !v$.$validationGroups.documentos.$error,
          'panel-danger': v$.$validationGroups.documentos.$error,
        }"
        class="panel"
      >
        <div id="docs_panel_titulo" class="panel-heading" role="tab">
          <h4 class="panel-title">
            Documentos
            <span class="pull-right">{{ resumoDocumentos }}</span>
          </h4>
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
              <div class="form-group">
                <label for="rg">RG</label>
                <input
                  id="rg"
                  v-model="paciente.docs_pessoais.rg_num"
                  data-test-id="input-rg"
                  type="text"
                  class="form-control"
                  name="rg"
                  placeholder="R.G."
                />
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
              <div class="form-group">
                <label for="orgao_exp">Órgão Expedidor</label>
                <input
                  id="orgao_exp"
                  v-model="paciente.docs_pessoais.rg_oe"
                  data-test-id="input-orgao_exp"
                  type="text"
                  class="form-control"
                  placeholder="Órgão Expedidor"
                />
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
              <div class="form-group">
                <label for="orgao_exp_uf">UF</label>
                <select
                  id="uf"
                  v-model="paciente.docs_pessoais.rg_oe_uf"
                  data-test-id="select-rg-oe-uf"
                  class="form-control"
                  name="uf"
                >
                  <option disabled value="">Selecione</option>
                  <option v-for="uf in ufs" :key="uf.id" :value="uf">{{
                    uf.sigla
                  }}</option>
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <div
                :class="{ 'has-error': v$.paciente.docs_pessoais.cpf.$error }"
                class="form-group"
              >
                <label for="cpf">CPF <sup>(1)</sup></label>
                <input
                  id="cpf"
                  v-model="paciente.docs_pessoais.cpf"
                  v-mask="'999.999.999-99'"
                  data-test-id="input-docs-pessoais-cpf"
                  type="type"
                  class="form-control"
                  placeholder="CPF"
                  @input="v$.paciente.docs_pessoais.cpf.$touch()"
                />
                <span v-if="v$.paciente.docs_pessoais.cpf.$dirty">
                  <span
                    v-if="!v$.paciente.docs_pessoais.cpf.required"
                    class="help-block"
                    >Campo é obrigatório.</span
                  >
                  <span
                    v-if="
                      !v$.paciente.docs_pessoais.cpf.isUnique &&
                      v$.paciente.docs_pessoais.cpf.$error
                    "
                    class="help-block"
                    >Já existe um paciente com este CPF.</span
                  >
                  <span
                    v-if="
                      !v$.paciente.docs_pessoais.cpf.cpfValido &&
                      v$.paciente.docs_pessoais.cpf.$error
                    "
                    class="help-block"
                    >CPF inválido.</span
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="{
          'panel-primary': !v$.$validationGroups.responsavel.$error,
          'panel-danger': v$.$validationGroups.responsavel.$error,
        }"
        class="panel"
      >
        <div id="info_resp" class="panel-heading" role="tab">
          <h4 class="panel-title">
            Responsável
            <span class="pull-right">{{ resumoResponsavel }}</span>
          </h4>
        </div>

        <div class="panel-body">
          <div v-show="!menorDeIdade" class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="checkbox">
                <label>
                  <input
                    v-model="dadosPacienteResponsavel"
                    data-test-id="input-dadospacienteresponsavel"
                    type="checkbox"
                  />
                  Copiar informações do paciente
                </label>
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-6">
              <div
                :class="{ 'has-error': v$.paciente.responsavel.nome.$error }"
                class="form-group"
              >
                <label for="nome"
                  >Nome
                  <sup>(3)</sup>
                </label>
                <input
                  id="responsavel"
                  v-model="paciente.responsavel.nome"
                  data-test-id="input-responsavel"
                  type="text"
                  class="form-control"
                  placeholder="Nome do responsável"
                  @input="v$.paciente.responsavel.nome.$touch()"
                />
                <span v-if="v$.paciente.responsavel.nome.$dirty">
                  <span
                    v-if="!v$.paciente.responsavel.nome.required"
                    class="help-block"
                    >Campos obrigatórios, para menor de 18 anos.</span
                  >
                  <span
                    v-if="!v$.paciente.responsavel.nome.minLength"
                    class="help-block"
                    >Campo deve ter pelo menos
                    {{ v$.paciente.responsavel.nome.$params.minLength.min }}
                    letras.</span
                  >
                  <span
                    v-if="!v$.paciente.responsavel.nome.maxLength"
                    class="help-block"
                    >Campo deve ter no máximo
                    {{ v$.paciente.responsavel.nome.$params.maxLength.max }}
                    letras.</span
                  >
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
              <div
                :class="{ 'has-error': v$.paciente.responsavel.cpf.$error }"
                class="form-group"
              >
                <label for="cpf_responsavel"
                  >CPF
                  <sup>(3)</sup>
                </label>
                <input
                  id="cpf_responsavel"
                  v-model="paciente.responsavel.cpf"
                  v-mask="'999.999.999-99'"
                  data-test-id="input-cpf_responsavel"
                  type="text"
                  class="form-control"
                  placeholder="CPF do responsável"
                  @input="v$.paciente.responsavel.cpf.$touch()"
                />
                <span v-if="v$.paciente.responsavel.cpf.$dirty">
                  <span
                    v-if="!v$.paciente.responsavel.cpf.required"
                    class="help-block"
                    >Campos obrigatórios, para menor de 18 anos.</span
                  >
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
              <div
                :class="{
                  'has-error': v$.paciente.responsavel.telefone.$error,
                }"
                class="form-group"
              >
                <label for="telefone_responsavel"
                  >Telefone <sup>(3)</sup></label
                >
                <input
                  id="telefone_responsavel"
                  v-model="paciente.responsavel.telefone"
                  v-mask="'(99) 9999-9999'"
                  data-test-id="input-telefone_responsavel"
                  type="text"
                  class="form-control"
                  placeholder="Telefone do responsável"
                />
                <span v-if="v$.paciente.responsavel.telefone.$dirty">
                  <span
                    v-if="!v$.paciente.responsavel.telefone.required"
                    class="help-block"
                    >Celular ou Telefone para contato são obrigatórios.</span
                  >
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
              <div
                :class="{ 'has-error': v$.paciente.responsavel.celular.$error }"
                class="form-group"
              >
                <label for="celular_responsavel">Celular <sup>(3)</sup></label>
                <input
                  id="celular_responsavel"
                  v-model="paciente.responsavel.celular"
                  v-mask="'(99) 99999-9999'"
                  data-test-id="input-celular_responsavel"
                  type="text"
                  class="form-control"
                  placeholder="Celular do responsável"
                />
                <span v-if="v$.paciente.responsavel.celular.$dirty">
                  <span
                    v-if="!v$.paciente.responsavel.celular.required"
                    class="help-block"
                    >Celular ou Telefone para contato são obrigatórios.</span
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel panel-primary">
        <div id="plano_panel_titulo" class="panel-heading" role="tab">
          <h4 class="panel-title"> Convênios </h4>
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <button
                id="adicionarConveniosBtn"
                data-test-id="button-adicionarconveniosbtn"
                type="button"
                name="adicionarConvenioBtn"
                class="btn btn-success pull-right"
                @click="adicionarNovoConvenio()"
                >Adicionar convênio</button
              >
            </div>
          </div>
          <div v-if="paciente.convenios.length" class="row">
            <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
              <label>Convênio</label>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
              <label>Plano</label>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
              <label>Matrícula</label>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
              <label>Validade</label>
            </div>
          </div>
          <div
            v-for="convenio in paciente.convenios"
            :key="convenio._id"
            class="row"
          >
            <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
              <div class="form-group form-group-sm">
                <select
                  id="convenioInput"
                  v-model="convenio.nome"
                  data-test-id="select-convenioinput"
                  class="form-control"
                  name="convenioInput"
                >
                  <option value="">Selecione o convênio</option>
                  <option
                    v-for="c in conveniosDisponiveis"
                    :key="c._id"
                    :value="c.nome"
                    >{{ c.nome }}</option
                  >
                </select>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
              <div v-if="!convenio.particular" class="form-group form-group-sm">
                <input
                  id="plano"
                  v-model="convenio.plano"
                  data-test-id="input-plano"
                  type="text"
                  class="form-control"
                  placeholder="Plano"
                />
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
              <div v-if="!convenio.particular" class="form-group form-group-sm">
                <input
                  id="matricula_plano"
                  v-model="convenio.matricula"
                  data-test-id="input-matricula_plano"
                  type="text"
                  class="form-control"
                  placeholder="Matrícula do plano"
                />
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
              <div v-if="!convenio.particular" class="form-group form-group-sm">
                <div id="validade" class="input-group input-group-sm">
                  <input
                    v-model="convenio.validade"
                    v-mask="'99/99/9999'"
                    data-test-id="input-convenio-validade"
                    type="text"
                    class="form-control"
                    placeholder="Validade (DD/MM/AAAA)"
                  />
                  <div class="input-group-addon">
                    <span
                      type="button"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="fa fa-calendar" />
                    </span>
                    <span class="dropdown-menu dropdown-menu-right">
                      <li>
                        <DatePicker
                          v-model="convenio.validade"
                          :today-btn="false"
                          :clear-btn="false"
                          :format="'dd/MM/yyyy'"
                          :close-on-selected="true"
                          :date-parser="dataParser"
                          class="date-picker"
                        />
                      </li>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
              <button
                v-if="!convenio.particular"
                data-test-id="button-removerconvenio-37"
                type="button"
                class="btn btn-danger btn-sm"
                @click="removerConvenio(convenio)"
                ><span class="fa fa-trash" /> Remover</button
              >
            </div>
          </div>
        </div>
      </div>
      <div
        :class="{
          'panel-primary': !v$.paciente.indicacao.$error,
          'panel-danger': v$.paciente.indicacao.$error,
        }"
        class="panel"
      >
        <div id="obs_panel_titulo" class="panel-heading" role="tab">
          <h4 class="panel-title">
            Indicação e Observações
            <span class="pull-right">{{ resumoIndicacaoObservacao }}</span>
          </h4>
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <label>
                <input
                  v-model="paciente.riscoDeQueda"
                  data-test-id="input-paciente-riscodequeda"
                  style="margin-right: 8px"
                  type="checkbox"
                />
                Risco de queda
              </label>
            </div>
          </div>

          <br />

          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <div
                :class="{ 'has-error': v$.paciente.indicacao.valor.$error }"
                class="form-group"
              >
                <label for="indicacao">Indicação <sup>(1)</sup></label>
                <select
                  id="indicacao"
                  v-model="paciente.indicacao"
                  data-test-id="select-indicacao"
                  class="form-control"
                  name="indicacao"
                >
                  <option
                    v-for="indicacao in indicacoes"
                    :key="indicacao.valor"
                    :value="indicacao"
                    >{{ indicacao.valor }}</option
                  >
                </select>
                <span v-if="v$.paciente.indicacao.valor.$dirty">
                  <span
                    v-if="!v$.paciente.indicacao.valor.required"
                    class="help-block"
                    >Campo obrigatório.</span
                  >
                </span>
              </div>
            </div>
            <div
              v-if="paciente.indicacao.valor === 'Médico'"
              class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
            >
              <div class="form-group">
                <label>Médico</label>
                <BuscarSelecionar
                  :lista="medicos"
                  :selecionado="paciente.indicacao.medico"
                  :minimo="1"
                  @selecionar="selecionarMedico"
                  @limpar="limparMedico"
                  @recuperar="recuperarMedico"
                />
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <label for="observacoes">Observações</label>
              <textarea
                id="obs"
                v-model="paciente.observacao"
                data-test-id="textarea-obs"
                class="form-control"
                rows="4"
                placeholder="Observações a cerca do paciente."
              />
            </div>
          </div>
        </div>
      </div>
      <p>(1) Campos obrigatórios.</p>
      <p>(2) Celular ou Telefone para contato são obrigatórios.</p>
      <p>(3) Campos obrigatórios, para menores de 18 anos.</p>
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {
  email,
  helpers,
  maxLength,
  minLength,
  required,
  requiredIf,
  requiredUnless,
} from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import { DatePicker } from 'uiv'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import { useMenu } from '@/composables/useMenu'
import { dominioMixin } from '@/mixins/DominioMixin'
import router from '@/router'
import CepServico from '@/servicos/CepServico'
import ConvenioServico from '@/servicos/ConvenioServico'
import EstadoServico from '@/servicos/EstadoServico'
import MedicoServico from '@/servicos/MedicoServico'
import MensagemServico from '@/servicos/MensagemServico'
import PacienteServico from '@/servicos/PacienteServico'
import CpfValidador from '@/validadores/Cpf'

const pacienteServico = new PacienteServico()
const convenioServico = new ConvenioServico()
const mensagemServico = new MensagemServico()
const medicoServico = new MedicoServico()
const estadoServico = new EstadoServico()
const cepServico = new CepServico()
const cpfValidador = new CpfValidador()

export default {
  name: 'PacienteCadastro',
  components: { DatePicker, BuscarSelecionar, BlocoFormularioCadastro },
  directives: { mask: AwesomeMask },
  mixins: [dominioMixin],
  setup() {
    useMenu(7)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      conveniosDisponiveis: [],
      indicacoes: [],
      medicos: [],
      sexos: [],
      profissoes: [],
      estados_civis: [],
      ufs: [],
      cidades: [],
      dadosPacienteResponsavel: false,
      paciente: {
        nome: '',
        nome_social: '',
        data_nascimento: '',
        estado_civil: '',
        sexo: '',
        profissao: '',
        observacao: '',
        ativo: true,
        responsavel: {
          nome: '',
          cpf: '',
          telefone: '',
          celular: '',
        },
        endereco: {
          cep: '',
          bairro: '',
          endereco: '',
          uf: '',
          cidade: '',
          numero: '',
          complemento: '',
        },
        contato: {
          email: '',
          celular: '',
          telefone: '',
        },
        contato_emergencia: {
          nome: '',
          cpf: '',
          telefone: '',
          celular: '',
        },
        docs_pessoais: {
          rg_num: '',
          rg_oe: '',
          rg_oe_uf: '',
          cpf: '',
        },
        convenios: [],
        indicacao: {
          valor: '',
          medico: {},
        },
        riscoDeQueda: false,
      },
    }
  },
  validations: {
    paciente: {
      nome: { required, minLength: minLength(5), maxLength: maxLength(70) },
      data_nascimento: { required },
      contato: {
        celular: {
          required: requiredIf(function () {
            return !this.paciente.contato.telefone
          }),
        },
        telefone: {
          required: requiredIf(function () {
            return !this.paciente.contato.celular
          }),
        },
        email: { email },
      },
      contato_emergencia: {
        nome: { required },
        celular: { required },
      },
      responsavel: {
        nome: {
          minLength: minLength(5),
          maxLength: maxLength(70),
          required: requiredIf(function () {
            return this.menorDeIdade
          }),
        },
        cpf: {
          required: requiredIf(function () {
            return this.menorDeIdade
          }),
        },
        celular: {
          required: requiredIf(function () {
            return this.menorDeIdade && !this.paciente.responsavel.telefone
          }),
        },
        telefone: {
          required: requiredIf(function () {
            return this.menorDeIdade && !this.paciente.responsavel.celular
          }),
        },
      },
      docs_pessoais: {
        cpf: {
          required: requiredUnless(function () {
            return this.menorDeIdade
          }),
          cpfValido(cpf) {
            if (cpf === '') {
              return true
            } else {
              return cpfValidador.valido(cpf)
            }
          },
          isUnique: helpers.withAsync(async function (valor) {
            if (valor === '' || valor.length < 14 || this.paciente._id) {
              return true
            }

            const cpf = valor.replace(/\./g, '').replace(/-/g, '')
            const ativo = true
            const result = await pacienteServico.recuperarTodos({ cpf, ativo })

            if (!Array.isArray(result?.pacientes)) {
              return true
            }

            return result.pacientes.length === 0
          }),
        },
      },
      convenios: { required },
      indicacao: {
        valor: { required },
      },
    },
    $validationGroups: {
      geral: ['paciente.nome', 'paciente.data_nascimento'],
      contato: [
        'paciente.contato.celular',
        'paciente.contato.telefone',
        'paciente.contato.email',
      ],
      contato_emergencia: [
        'paciente.contato_emergencia.nome',
        'paciente.contato_emergencia.celular',
      ],
      responsavel: [
        'paciente.responsavel.nome',
        'paciente.responsavel.cpf',
        'paciente.responsavel.telefone',
        'paciente.responsavel.celular',
      ],
      documentos: ['paciente.docs_pessoais.cpf'],
    },
  },
  computed: {
    resumoIndicacaoObservacao() {
      let result = ''
      result += this.paciente.indicacao.valor
        ? ` Indicação: ${this.paciente.indicacao.valor}`
        : ''
      result += this.paciente.observacao
        ? ` Observacao: ${this.paciente.observacao}`
        : ''
      return result
    },
    resumoResponsavel() {
      let result = ''
      result += this.paciente.responsavel.nome
        ? this.paciente.responsavel.nome
        : ''
      result += this.paciente.responsavel.cpf
        ? `, CPF: ${this.paciente.responsavel.cpf}`
        : ''
      result += this.paciente.responsavel.telefone
        ? `, Telefone: ${this.paciente.responsavel.telefone}`
        : ''
      result += this.paciente.responsavel.celular
        ? `, Celular: ${this.paciente.responsavel.celular}`
        : ''
      return result
    },
    resumoDocumentos() {
      if (
        this.paciente.docs_pessoais.cpf &&
        this.paciente.docs_pessoais.rg_num
      ) {
        return `CPF: ${this.paciente.docs_pessoais.cpf} / RG: ${this.paciente.docs_pessoais.rg_num}`
      } else if (
        !this.paciente.docs_pessoais.cpf &&
        this.paciente.docs_pessoais.rg_num
      ) {
        return `RG: ${this.paciente.docs_pessoais.rg_num}`
      } else if (
        this.paciente.docs_pessoais.cpf &&
        !this.paciente.docs_pessoais.rg_num
      ) {
        return `CPF: ${this.paciente.docs_pessoais.cpf}`
      } else {
        return ''
      }
    },
    resumoContato() {
      if (this.paciente.contato.celular && this.paciente.contato.telefone) {
        return `${this.paciente.contato.celular} / ${this.paciente.contato.telefone}`
      } else if (
        !this.paciente.contato.celular &&
        this.paciente.contato.telefone
      ) {
        return this.paciente.contato.telefone
      } else if (
        this.paciente.contato.celular &&
        !this.paciente.contato.telefone
      ) {
        return this.paciente.contato.celular
      } else {
        return ''
      }
    },
    resumoContatoEmergencia() {
      if (
        this.paciente.contato_emergencia &&
        this.paciente.contato_emergencia.celular
      ) {
        return this.paciente.contato_emergencia.celular
      } else {
        return ''
      }
    },
    resumoEndereco() {
      const ufObj =
        this.paciente.endereco &&
        this.paciente.endereco.uf &&
        typeof this.paciente.endereco.uf === 'object'
          ? this.paciente.endereco.uf
          : null

      if (
        this.paciente.endereco.endereco ||
        this.paciente.endereco.numero ||
        this.paciente.endereco.bairro ||
        this.paciente.endereco.cidade ||
        this.paciente.endereco.uf
      ) {
        const end = this.paciente.endereco.endereco
        const num = this.paciente.endereco.numero
        const bairro = this.paciente.endereco.bairro
        const cidade =
          this.paciente.endereco.cidade && this.paciente.endereco.cidade.nome
            ? this.paciente.endereco.cidade.nome
            : ''
        const uf = ufObj && ufObj.sigla ? ufObj.sigla : ''
        return `${end}, ${num} - ${bairro} - ${cidade}/${uf}`
      } else {
        return ''
      }
    },
    menorDeIdade() {
      if (this.paciente.data_nascimento) {
        const hoje = moment(new Date())
        const nascimento = moment(this.paciente.data_nascimento, 'DD/MM/YYYY')
        const menor = hoje.diff(nascimento, 'years') < 18
        return menor
      }
      return false
    },
  },
  watch: {
    dadosPacienteResponsavel() {
      if (this.dadosPacienteResponsavel) {
        this.paciente.responsavel.nome = this.paciente.nome
        this.paciente.responsavel.cpf = this.paciente.docs_pessoais.cpf
        this.paciente.responsavel.telefone = this.paciente.contato.telefone
        this.paciente.responsavel.celular = this.paciente.contato.celular
      } else {
        this.paciente.responsavel.nome = ''
        this.paciente.responsavel.cpf = ''
        this.paciente.responsavel.telefone = ''
        this.paciente.responsavel.celular = ''
      }
    },
    'paciente.nome'() {
      if (this.dadosPacienteResponsavel) {
        this.paciente.responsavel.nome = this.paciente.nome
      }
    },
    'paciente.cpf'() {
      if (this.dadosPacienteResponsavel) {
        this.paciente.responsavel.cpf = this.paciente.cpf
      }
    },
    'paciente.contato.telefone'() {
      if (this.dadosPacienteResponsavel) {
        this.paciente.responsavel.telefone = this.paciente.telefone
      }
    },
    'paciente.contato.celular'() {
      if (this.dadosPacienteResponsavel) {
        this.paciente.responsavel.celular = this.paciente.celular
      }
    },
  },
  mounted() {
    this.recuperarConveniosDisponiveis()
    this.recuperarValoresDominio('Indicação').then((res) => {
      this.indicacoes = res.valores
    })
    this.recuperarValoresDominio('Sexo').then((res) => {
      this.sexos = res.valores
    })
    this.recuperarValoresDominio('Profissões').then((res) => {
      this.profissoes = res.valores
    })
    this.recuperarValoresDominio('EstadoCivil').then((res) => {
      this.estados_civis = res.valores
    })

    estadoServico.recuperarUfs().then((res) => {
      this.ufs = res.estados
      this.recuperarPaciente()
    })
  },
  methods: {
    alterouCep() {
      if (
        this.paciente.endereco.cep &&
        this.paciente.endereco.cep.length === 9
      ) {
        const cepValor = this.paciente.endereco.cep.replace('-', '')

        cepServico.cep(cepValor).then((result) => {
          this.paciente.endereco.bairro = result.bairro
          this.paciente.endereco.endereco = result.logradouro
          this.paciente.endereco.uf = this.ufs.find(
            (e) => e.sigla === result.uf
          )
          this.recuperarCidades(result.localidade)
        })
      }
    },
    recuperarCidades(nomeCidade) {
      if (this.paciente.endereco.uf._id) {
        estadoServico
          .recuperarCidades(this.paciente.endereco.uf.sigla)
          .then((res) => {
            this.cidades = res.cidades

            if (typeof nomeCidade !== 'undefined' && nomeCidade !== '') {
              this.paciente.endereco.cidade = this.cidades.find(
                (e) => e.nome === nomeCidade
              )
            }
          })
      }
    },
    adicionarNovoConvenio() {
      this.paciente.convenios.unshift({
        nome: '',
        plano: '',
        matricula: '',
        validade: '',
        particular: false,
      })
    },
    removerConvenio(conv) {
      const index = this.paciente.convenios.indexOf(conv)
      this.paciente.convenios.splice(index, 1)
    },
    recuperarMedico(filtro) {
      medicoServico
        .recuperarTodos({
          nome: filtro.palavra,
          skip: (filtro.pagina - 1) * filtro.limite,
          limit: filtro.limite,
          orderBy: filtro.chave,
        })
        .then((result) => {
          this.medicos = result.medicos
        })
    },
    limparMedico() {
      this.paciente.indicacao.medico.cbo = {}
      this.paciente.indicacao.medico.conselho = ''
      this.paciente.indicacao.medico._id = ''
      this.paciente.indicacao.medico.nome = ''
      this.paciente.indicacao.medico.numeroConselho = ''
      this.paciente.indicacao.medico.ufConselho = ''
    },
    selecionarMedico(medico) {
      this.paciente.indicacao.medico = medico
    },
    recuperarConveniosDisponiveis() {
      convenioServico.recuperarTodos({}).then((result) => {
        this.conveniosDisponiveis = result.convenios
        if (!this.paciente.convenios.find((c) => c.particular)) {
          this.conveniosDisponiveis.forEach((c) => {
            if (c.particular) {
              c.plano = c.nome
              this.paciente.convenios.unshift({
                nome: c.nome,
                plano: c.plano,
                _id: c._id,
                particular: c.particular,
              })
            }
          })
        }
      })
    },
    recuperarPaciente() {
      const pacienteId = this.$route.params.id

      if (pacienteId) {
        pacienteServico.recuperar(pacienteId).then((result) => {
          this.paciente._id = pacienteId
          this.paciente.nome = result.paciente.nome
          this.paciente.nome_social = result.paciente.nome_social
          this.paciente.estado_civil = result.paciente.estado_civil
          this.paciente.sexo = result.paciente.sexo
          this.paciente.profissao = result.paciente.profissao
          this.paciente.observacao = result.paciente.observacao
          this.paciente.indicacao = result.paciente.indicacao
            ? result.paciente.indicacao
            : { valor: '', medico: {} }
          if (result.paciente.responsavel) {
            this.paciente.responsavel.nome = result.paciente.responsavel.nome
            this.paciente.responsavel.cpf = result.paciente.responsavel.cpf
            this.paciente.responsavel.telefone =
              result.paciente.responsavel.telefone
            this.paciente.responsavel.celular =
              result.paciente.responsavel.celular
          }

          this.paciente.endereco.cep = result.paciente.endereco.cep
          this.paciente.endereco.endereco = result.paciente.endereco.endereco
          this.paciente.endereco.numero = result.paciente.endereco.numero
          this.paciente.endereco.complemento =
            result.paciente.endereco.complemento
          this.paciente.endereco.bairro = result.paciente.endereco.bairro

          if (result.paciente.contato) {
            this.paciente.contato.email = result.paciente.contato.email
            this.paciente.contato.celular = result.paciente.contato.celular
            this.paciente.contato.telefone = result.paciente.contato.telefone
          }
          const nascimento = moment(result.paciente.data_nascimento).format(
            'DD/MM/YYYY'
          )
          this.paciente.data_nascimento = nascimento

          if (!this.menorDeIdade && this.paciente.docs_pessoais) {
            this.paciente.docs_pessoais.rg_num =
              result.paciente.docs_pessoais.rg_num
            this.paciente.docs_pessoais.rg_oe =
              result.paciente.docs_pessoais.rg_oe
            this.paciente.docs_pessoais.cpf = result.paciente.docs_pessoais.cpf
          }

          if (result.paciente.endereco.uf) {
            const uf = this.ufs.find(
              (e) => e.sigla === result.paciente.endereco.uf
            )
            if (uf) {
              this.paciente.endereco.uf = uf
              this.recuperarCidades(result.paciente.endereco.cidade)
            }
          }

          if (!this.menorDeIdade && result.paciente.docs_pessoais.rg_oe_uf) {
            const ufrg = this.ufs.find(
              (e) => e.sigla === result.paciente.docs_pessoais.rg_oe_uf
            )
            if (ufrg) {
              this.paciente.docs_pessoais.rg_oe_uf = ufrg
            }
          }

          this.paciente.convenios = result.paciente.convenios
          this.paciente.convenios.forEach((c) => {
            if (!c.particular && c.validade) {
              const validade = moment(c.validade).format('DD/MM/YYYY')
              c.validade = validade
            }

            convenioServico.recuperar(c._id).then((res) => {
              c.ans = res.convenio.ans
              c.particular = res.convenio.particular
            })
          })
          this.paciente.riscoDeQueda = result.paciente.riscoDeQueda
          this.paciente.contato_emergencia = Object.assign(
            { nome: '', cpf: '', telefone: '', celular: '' },
            result.paciente.contato_emergencia || {}
          )
        })
      }
    },
    aguardarValidacoesPaciente(timeout = 3000, intervalo = 50) {
      return new Promise((resolve) => {
        const inicio = Date.now()
        const timer = setInterval(() => {
          const expirou = Date.now() - inicio >= timeout
          if (!this.v$.paciente.$pending || expirou) {
            clearInterval(timer)
            resolve()
          }
        }, intervalo)
      })
    },
    async salvar() {
      this.v$.$touch()
      await this.aguardarValidacoesPaciente()

      if (this.v$.paciente.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
      } else {
        const uf = this.paciente.endereco.uf
        const ufrg = this.paciente.docs_pessoais.rg_oe_uf
        const cidade = this.paciente.endereco.cidade
        const nascimento = this.paciente.data_nascimento
        const cpf = this.paciente.docs_pessoais.cpf
        const cpfResp = this.paciente.responsavel.cpf

        this.paciente.endereco.uf = uf?.sigla
        this.paciente.endereco.cidade = cidade?.nome
        this.paciente.data_nascimento = moment(
          nascimento,
          'DD/MM/YYYY'
        ).toISOString()

        if (cpfResp) {
          this.paciente.responsavel.cpf = cpfResp
            .replace(/\./g, '')
            .replace(/-/g, '')
        }

        if (this.menorDeIdade) {
          delete this.paciente.docs_pessoais
        } else {
          this.paciente.docs_pessoais.rg_oe_uf = ufrg.sigla
          this.paciente.docs_pessoais.cpf = cpf
            .replace(/\./g, '')
            .replace(/-/g, '')
        }

        this.paciente.convenios.forEach((c) => {
          const convEncontrado = this.conveniosDisponiveis.find(
            (c2) => c2.nome === c.nome
          )
          c._id = convEncontrado._id

          if (c.validade) {
            c.validade = moment(c.validade, 'DD/MM/YYYY').toISOString()
          }
        })

        const cpfContatoEmergencia = this.paciente.contato_emergencia.cpf
        if (cpfContatoEmergencia) {
          this.paciente.contato_emergencia.cpf = cpfContatoEmergencia
            .replace(/\./g, '')
            .replace(/-/g, '')
        }

        const postSave = (result) => {
          if (!result.erro) {
            router.replace({ name: 'Pacientes' })
          } else {
            mensagemServico.alerta(result.erro.content, result.erro.title)
            this.paciente.endereco.uf = uf
            this.paciente.docs_pessoais.rg_oe_uf = ufrg
            this.paciente.endereco.cidade = cidade
            this.paciente.data_nascimento = nascimento
            this.paciente.docs_pessoais.cpf = cpf
            this.paciente.responsavel.cpf = cpfResp
            this.paciente.contato_emergencia.cpf = cpfContatoEmergencia
          }
        }

        if (this.paciente._id) {
          pacienteServico
            .atualizar(this.paciente._id, this.paciente)
            .then((result) => {
              postSave(result)
            })
        } else {
          pacienteServico.criar(this.paciente).then((result) => {
            postSave(result)
          })
        }
      }
    },
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
  },
}
</script>
